import t from 'tcomb';

export default t.interface({
  group_id: t.String
}, { strict: true, name: 'Groups' });

